




















































import { Component, Vue, Prop} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
@Component({
    name:'outsideUnitManage'
})
export default class OutsideUnitManage extends AbpBase  {
    initData:any = {
        searchData: {
            SignYear: null,
            BelongOrgId: null,
            ContractType: null,
            Keyword: null
        },
        dicData: {
            
        },
        tableData: {
            totalCount: 0,
            loading: true,
            title: [
                {
                    title: '单位名称',
                    key: 'unitName',
                    align: 'center'
                },
                {
                    title: '单位地址',
                    key: 'unitAddress',
                    align: 'center'
                },
                {
                    title: '法人代表',
                    key: 'legalRepresentative',
                    align: 'center'
                },
                {
                    title: '纳税人识别号',
                    key: 'taxpayerIdentifyNumber',
                    align: 'center'
                },
                {
                    title: '注册年份',
                    key: 'registeredYear',
                    align: 'center'
                },
                {
                    title: '联系电话',
                    key: 'contactNumber',
                    align: 'center'
                },
                {
                    title: '联系人',
                    key: 'contactor',
                    align: 'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.ShowModal('edit', params.row.id)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.OutsideUnitDelete(params.row.id);
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            content: []
        },
        modalData: {
            status: false,
            btnSatus: true,
        }
    }
    //获取列表数据
    async GetData() {
        this.initData.tableData.loading = true;
        await Ajax.get('/api/services/app/Contract/GetAllExternalUnitByPagingAsync', {params: this.initData.searchData}).then((res:any)=>{                
            this.initData.tableData.loading = false;
            let temp = res.data.result;
            if(!temp || temp.totalCount == 0){
                this.$Message.error('暂无数据！');
                return;
            }
            this.initData.tableData.content = temp.items;
            this.initData.tableData.totalCount = temp.totalCount;
        })
    }
    ShowModal(type:any, id:any) {
        this.initData.modalData = {
            status: false,
            btnSatus: true
        };
        if(type == 'edit'){
            this.OutsideUnitEdit(id);
        }else{                
            this.initData.modalData.status = true;
        }
        (this as any).$refs.addForm.resetFields();
        this.initData.modalData.type = type;
    }
    //新增外协单位
    async OutsideUnitAdd() {
        (this as any).$refs.addForm.validate((valid:boolean)=>{
            if(valid){
                this.initData.modalData.registeredYear = this.initData.modalData.registeredDate ? this.initData.modalData.registeredDate.getFullYear() : undefined;
                if(this.initData.modalData.type == 'add'){                        
                    Ajax.post('/api/services/app/Contract/CreateExternalUnitAsync', this.initData.modalData).then(()=>{
                        this.initData.modalData.status = false;
                        this.$Message.success('新增成功!');
                        this.GetData();
                    })
                }else{
                    Ajax.put('/api/services/app/Contract/UpdateExternalUnitAsync', this.initData.modalData).then(()=>{
                        this.initData.modalData.status = false;
                        this.$Message.success('修改成功!');
                        this.GetData();
                    })
                }
            }else{                    
                setTimeout(() => {
                    this.initData.modalData.btnSatus = false;
                    this.$nextTick(() => {
                        this.initData.modalData.btnSatus = true;
                    });
                }, 1000);
            }
        });
    }
    //编辑
    async OutsideUnitEdit(id:any) {
        //获取详情
        await Ajax.get('/api/services/app/Contract/GetExternalUnitDetailInfoAsync?id='+id).then((res:any)=>{
            Object.assign(this.initData.modalData, res.data.result);
            this.initData.modalData.status = true;
        });
    }
    //删除
    async OutsideUnitDelete(id:any) {            
        (this as any).$refs.addForm.validate((valid:boolean)=>{
            if(valid){
                Ajax.delete('/api/services/app/Contract/DeleteExternalUnitAsync?id='+id).then((res:any)=>{
                    this.initData.modalData.status = false;
                    this.$Message.success('操作成功!');
                    this.GetData();
                });
            }else{                    
                setTimeout(() => {
                    this.initData.modalData.btnSatus = false;
                    this.$nextTick(() => {
                        this.initData.modalData.btnSatus = true;
                    });
                }, 1000);
            }
        })
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    //初始化
    mounted() {
        this.GetData();
        if(this.$route.query.isContractComing == '1'){
            this.ShowModal('add', undefined);
        }
    }
    rules:any = {
        unitName: [{ required: true, message: '请填写外协单位名称', trigger: 'blur' }],
        contactNumber: [{ pattern: /^((0\d{2,3}-\d{7,8})|(1[357894]\d{9}))$/, message: '电话号码格式错误', trigger: 'blur' }]
    }
}
